import DropItemContainer from "../../ddTxtImg/model/DropItemContainer";



class SortStoryDropItemContainer extends DropItemContainer{


    constructor(){
        super()
    }



}

export default SortStoryDropItemContainer